module.exports = __webpack_public_path__ + "img/personal_library.2a30a193.svg";